/**
 * Standard table shell: TableContainer with its own horizontal/vertical
 * overflow, sticky header, size small. Callers supply header cells and
 * body rows; column semantics stay at the call site.
 */
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import type { ReactNode } from "react";

export type DataTableColumn = {
  key: string;
  label: ReactNode;
  align?: "left" | "right" | "center";
};

export function DataTable({
  columns,
  children,
  maxHeight,
  dense = true,
}: {
  columns: DataTableColumn[];
  /** Body rows (<TableRow> elements). */
  children: ReactNode;
  maxHeight?: number;
  /** size="small" by default; pass false for the comfortable density. */
  dense?: boolean;
}) {
  return (
    <TableContainer sx={{ maxHeight, overflowX: "auto" }}>
      <Table size={dense ? "small" : "medium"} stickyHeader>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.key} align={column.align}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
}
